import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { alertAction } from "../../../store/alert-store";
import Input from "../../UI/Input";
import "./ResetPassword.css";

const ResetPassword = () => {
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();

  useEffect(() => {
    document.title = `${endPoints.title} | Reset Password`;
  });

  const [ispassword, setIsPassword] = useState(null);

  const [emailLabel, setEmailLabel] = useState(null);
  const [confirmPassLabel, setConfirmPassLabel] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: resetPasswordRequest,
  } = useHttp();

  var strongRegex = new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
  );

  const passwordChangeHandler = (event) => {
    setPassword(event.target.value.trim());
    if (strongRegex.test(password)) {
      setEmailLabel("Valid");
      setIsPassword(true);
    } else {
      setEmailLabel("Invalid");
      setIsPassword(false);
    }
  };

  const confirmPasswordHandler = (event) => {
    if (password === event.target.value) {
      setIsPassword(true);
      setConfirmPassLabel("Matching");
      setConfirmPassword(event.target.value);
    } else {
      setIsPassword(false);
      setConfirmPassLabel("Not Matching");
    }
  };

  const resetFormHandle = (event) => {
    event.preventDefault();

    if (ispassword) {
      //   console.log("Hello");
      resetPasswordRequest(
        {
          url: endPoints.reset_password,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: {
            password,
            confirm_password: confirmPassword,
            token: query.get("token"),
            id: query.get("id"),
          },
        },
        responseData
      );
    }
  };

  const responseData = (response) => {
    let icon = "fa-check";
    dispatch(
      alertAction.showAlert({
        action: "show",
        alert_txt: response.message,
        alert_class: "success",
        alert_icon: icon,
      })
    );

    history.push("/login");
  };

  useEffect(() => {
    if (error && httpStatusCode) {
      let icon = "fa-user-slash";
      dispatch(
        alertAction.showAlert({
          action: "show",
          alert_txt: error,
          alert_class: "danger",
          alert_icon: icon,
        })
      );
      setError(null);
    }
  });

  return (
    <div className="login_m">
      <div className={`container `} id="container">
        <div className="overlay-container">
          <div className="overlay">
            <div className="overlay-panel overlay-right">
              <h1>Password Rules</h1>
              <ul className="float-left">
                <li>
                  <i className="fas fa-hand-point-right"></i> The string must
                  contain at least 1 lowercase alphabetical character
                </li>
                <li>
                  <i className="fas fa-hand-point-right"></i> The string must
                  contain at least 1 uppercase alphabetical character
                </li>
                <li>
                  <i className="fas fa-hand-point-right"></i> The string must
                  contain at least 1 numeric character
                </li>
                <li>
                  <i className="fas fa-hand-point-right"></i> The string must
                  contain at least 1 special character
                </li>
                <li>
                  <i className="fas fa-hand-point-right"></i> The string must be
                  eight characters or longer
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="form-container sign-up-container"></div>
        <div className="form-container sign-in-container">
          <form onSubmit={resetFormHandle}>
            <h1>Reset Password</h1>

            <Input
              type="password"
              onChange={passwordChangeHandler}
              placeholder="Enter Password"
              className="rounded"
            />
            <label className="w-100 float-right">
              <small className={emailLabel}>{emailLabel}</small>
            </label>
            <Input
              type="password"
              onChange={confirmPasswordHandler}
              placeholder="Re-enter confirm Password"
              className="rounded"
            />
            <label className="w-100 float-right">
              <small>{confirmPassLabel}</small>
            </label>

            <button type="submit">Reset</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
